import { Component, h, JSX } from 'preact';
import VideoEndScreen from '../video-end-screen';
import cssStyles from './index.css';
import { EndScreenOrchestrator } from '../../lib/end-screen/orchestrator';
import {
  EndScreenOrigin,
  EndScreenType
} from '../../lib/end-screen/end-screen-types';
import { RootStore } from '../../../../common/js/stores/root.store';
import { isStandardBannersAdUnit } from '../../../../common/js/adUnit';
import { EndScreen } from '../../lib/end-screen/end-screen';
import { AdContextStore } from '../../../../common/js/stores/ad-context.store';

interface VideoSkinProps {
  videoDuration: number;
  isMediumRectangleAdUnit: boolean;
  isVideoCompleted: boolean;
  onRendered?: () => void;
  endScreen?: EndScreen;
  onClick: (source: string, event?: MessageEvent) => void;
}

interface WindowSize {
  width: number;
  height: number;
}

export default class VideoSkin extends Component<VideoSkinProps> {
  render(): JSX.Element {
    const { skinTop, skinBottom } =
      RootStore.getInstance().configStore.config.skin || {};

    const videoStore = RootStore.getInstance().videoStore;
    const windowSize: WindowSize = videoStore.windowSize.value;

    const isLandscape = windowSize.width > windowSize.height;

    const styles = {
      skinTop: {
        backgroundImage: `url(${skinTop})`
      },
      skinBottom: {
        backgroundImage: `url(${skinBottom})`
      }
    };

    const shouldDisplaySkin = (): boolean => {
      const endScreen = EndScreenOrchestrator.instance.endScreen;
      // TODO: Refactoring this to use VideoStore
      if (this.props.isVideoCompleted && endScreen) {
        if (endScreen.origin === EndScreenOrigin.VAST) {
          return false;
        } else if (
          endScreen.type === EndScreenType.HTML ||
          endScreen.type === EndScreenType.IFRAME
        ) {
          return false;
        }
      }

      // TODO: remove this condition when we have a proper way to handle skins in standard banners
      if (
        isStandardBannersAdUnit(
          AdContextStore.getInstance().adContext.adUnitType
        )
      ) {
        return false;
      }

      return Boolean(skinTop || skinBottom);
    };

    const isSkinDisplayed = shouldDisplaySkin();

    return (
      <div
        onClick={() => this.props.onClick('video')}
        className={cssStyles.videoSkinContainer}
      >
        {isSkinDisplayed && skinTop && !isLandscape && (
          <div
            id="skin_top"
            style={styles.skinTop}
            className={cssStyles.skinTop}
          />
        )}
        <VideoEndScreen
          {...this.props}
          // TODO: Stopping here for windowSize migration from props to store => to be done in https://jira.ogury.io/browse/SPY-15085
          windowSize={windowSize}
          shouldDisplaySkin={isSkinDisplayed}
        />
        {isSkinDisplayed && skinBottom && !isLandscape && (
          <div
            id="skin_bottom"
            style={styles.skinBottom}
            className={cssStyles.skinBottom}
          />
        )}
      </div>
    );
  }
}
